module.exports = __webpack_public_path__ + "img/speaker17.bd62f579.png";